import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../api/ApiSettings";

export const fetchTerms = createAsyncThunk(
  'terms/fetchTerms',
  async () => {
      const response = await fetch(`${API_URL}util/getSettingValue?settingName=URLForTermOfUse`);
      const terms = await response.json();
      return terms;
    
  });

  const termsSlice = createSlice({
    name: 'terms',
    initialState:{
      termOfUseURL: null,
      termOfUseForWarranty: "https://firma-pro.com/media/wysiwyg/do-pobrania/gwarancje/2022/Regulamin_rekojmia_PRO_2022.pdf",
      termOfUseForSalesWarranty:"https://firma-pro.com/media/wysiwyg/do-pobrania/gwarancje/2022/Regulamin_gwarancja_PRO_2022.pdf",
    },
    reducers: {
      getTermsForWarranty: (state,action) =>{
        state.termOfUseForWarranty = action.payload;
      },
      getTermsForSalesWarranty: (state,action) =>{
        state.termOfUseForSalesWarranty = action.payload;
      }
    },
    extraReducers: (builder) =>{
      builder.addCase(fetchTerms.fulfilled, (state,action)=>{
        state.termOfUseURL = action.payload;
      });
    }
  });

  export const {getTermsForSalesWarranty,getTermsForWarranty} = termsSlice.actions;
  export default termsSlice.reducer;
